import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faYoutube, faTwitter, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons'

import './social_list.scss'

export default () => {
  return (
    <ul className="social-list list">
      <li>
        <a target="_blank" href="https://www.facebook.com/metalcorp1/">
          <FontAwesomeIcon icon={faFacebookF} />
        </a>
      </li>
      <li>
        <a target="_blank" href="https://www.youtube.com/channel/UCpOWF0aNV1w1R7BXJ0mFUeA">
          <FontAwesomeIcon icon={faYoutube} />
        </a>
      </li>
      <li>
        <a target="_blank" href="https://twitter.com/Metalcorp1">
          <FontAwesomeIcon icon={faTwitter} />
        </a>
      </li>
      <li>
        <a target="_blank" href="https://au.linkedin.com/company/metalcorpsteel">
          <FontAwesomeIcon icon={faLinkedinIn} />
        </a>
      </li>
      <li>
        <a target="_blank" href="https://www.instagram.com/metalcorp.n.s.w/">
          <FontAwesomeIcon icon={faInstagram} />
        </a>
      </li>
    </ul>
  )
}
